import { combineReducers } from 'redux'

import records from './records'
import stagedRecords from './stagedRecords'
import uiFlags from './uiFlags'

export default combineReducers({ records, stagedRecords, uiFlags })
